export default __webpack_public_path__ + "static/go_logo-c24889dd4fa61bf2df6633da077425a7.png";